import React from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { PartnerContactData } from "@/pages/partners/contacts/types";
import PartnerContactTopFields from "@/components/layouts/PartnerContactTopFields";
import PartnerContactDetailFields from "@/components/layouts/PartnerContactDetailFields/PartnerContactDetailFields";
import InvolvedIn from "@/components/layouts/InvolvedIn";

interface Props {
  partnerContact: PartnerContactData | undefined;
  onUpdatePartnerContactField: (
    field: string,
    newValue: string | number | boolean | string[]
  ) => void;
  onCreateLead?: () => void;
  onCreateDeal?: () => void;
  onCreateContract?: () => void;
}

const PartnerContactQuickViewContent: React.FC<Props> = ({
  partnerContact,
  onUpdatePartnerContactField,
  onCreateLead,
  onCreateDeal,
  onCreateContract
}) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <PartnerContactTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        partnerContact={partnerContact}
        onUpdateField={onUpdatePartnerContactField}
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <InvolvedIn
          entityId={partnerContact?.id || ""}
          entityType={EntityType.PARTNER_CONTACT}
          className="min-h-fit"
          isQuickView
          onCreateLead={onCreateLead}
          onCreateDeal={onCreateDeal}
          onCreateContract={onCreateContract}
        />
        <PartnerContactDetailFields
          className="w-full px-4 min-h-fit"
          partnerContact={partnerContact}
          onUpdateField={onUpdatePartnerContactField}
          containerClassName="grid-cols-[minmax(0,30%),1fr]"
          isDrawerOpen={true}
          isQuickView
        />
      </div>
    </div>
  );
};

export default PartnerContactQuickViewContent;
